import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { decodeToken } from "../../utils/functions";
import SuspenseFallback from "../SuspenseFallback";

const AuthLayout = () => {
  const token = localStorage.getItem("accessToken");

  const role = decodeToken(token);

  if (role?.role === "JEWELLERY_BUYER")
    return <Navigate to={"/stocks-management"} />;
  else if (role?.role === "JEWELLERY_INSPECTOR")
    return <Navigate to={"/inspection-requests"} />;
  else if (role?.role === "TAQABETH_ENFORCER")
    return <Navigate to={"/request-management"} />;
  else if (role?.role === "ADMIN") return <Navigate to="/" />;
  else <Navigate to={"/"} />;

  // if (token) return <Navigate to="/businesses" />;
  // if (token) return <Navigate to="/" />;

  return (
    <Suspense fallback={<SuspenseFallback />}>
      <Outlet />
    </Suspense>
  );
};

export default AuthLayout;
